import { gql } from '@apollo/client';

const getProducts = gql`
  query GetProducts($filters: ProductFilters) {
    getProducts(filters: $filters) {
      id
      name
      code
      status
      accessType
      category
      location {
        code
        name
        terminal
      }
    }
  }
`;
export default getProducts;
